import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import InvoiceHtml from "../Pages/InvoiceHtml";
import Normal1InvoiceHtml from "../Pages/Normal1InvoiceHtml";
import SimpleInvoice from "../Pages/simpleInvoice";
import { useReactToPrint } from "react-to-print";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { AppStorage } from "../Utils/Context/AppContext";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../Utils";
import Request from "../Utils/Request/Request";
import InvoiceTemplate from "../Pages/InvoiceTemplate";
import Loader from "./Loader";

function PrintComponent() {
  let componentRef = useRef();
  const { id } = useParams();
  const AppContext = useContext(AppStorage);
  const [invoiceData, setInvoiceData] = useState(null);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getPrintInvoice = useCallback(() => {
    return Request.get(`/getPrintInvoice/${id}`)
      .then((result) => {
        setInvoiceData(result.data.invoice);
        setUserData(result.data.UserData);
      })
      .catch((err) => {
        console.log("Error: ", err);
        if (err.response?.status === 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }, [id]);

  useEffect(() => {
    if (AppContext?.userAuthToken) {
      getPrintInvoice();
    }

  }, [AppContext?.userAuthToken, getPrintInvoice]);

  useEffect(() => {
    window.history.pushState(null, "", window.location.pathname);

    const handleBackButton = (event) => {
      event.preventDefault();
      navigate("/all-invoices", { replace: true });
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  if (!invoiceData || !userData) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </Box>
    );
  }

  const invoiceType = userData?.invoiceType || AppContext?.userInfo?.invoiceType;
  const offerType = userData?.offerType || AppContext?.userInfo?.offerType;
  const isOffer = invoiceData?.OfferPrice === true || invoiceData?.OfferPrice === 1;
  const isSalesReturn = invoiceData?.salesReturn === true || invoiceData?.salesReturn === 1;

  return (
    <Box className="print-preview-page">
      <Box className="print-preview-actions" sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Box>
          <Button
            variant="contained"
            sx={{
              background: "#365b6d",
              "&:hover": { backgroundColor: "#365b6d" },
              marginTop: "30px",
              display: "flex",
              justifyContent: "end",
            }}
            onClick={handlePrint}
          >
            Print
          </Button>
        </Box>
      </Box>

      <Box className="print-preview" sx={{ marginTop: "20px" }}>
        {AppContext?.userInfo.role === "user" ? (
          invoiceData?.supplierInvoice === true ? (
            <InvoiceHtml ref={componentRef} flag={"purchases"} />
          ) : isOffer && offerType !== "normal" ? (
            <InvoiceTemplate ref={componentRef} flag={true} type={offerType} />
          ) : isOffer && (offerType === "normal" || offerType === "") ? (
            <InvoiceHtml ref={componentRef} flag={true} sales={false} />
          ) : invoiceType === "normal" && !isOffer && !isSalesReturn ? (
            <InvoiceHtml ref={componentRef} flag={false} sales={false} />
          ) : invoiceType === "normal1" && !isOffer && !isSalesReturn ? (
            <Normal1InvoiceHtml ref={componentRef} flag={false} sales={false} />
          ) : !isOffer && isSalesReturn ? (
            <InvoiceHtml ref={componentRef} flag={false} sales={true} />
          ) : invoiceType !== "simple" && invoiceType !== "normal" && invoiceType !== "normal1" ? (
            <InvoiceTemplate
              ref={componentRef}
              type={invoiceType}
              flag={false}
            />
          ) : (
            <SimpleInvoice ref={componentRef} />
          )
        ) : AppContext?.userInfo.role === "admin" &&
          userData?.invoiceType === "normal" ? (
          <InvoiceHtml ref={componentRef} flag={false} sales={false} />
        ) : AppContext?.userInfo.role === "admin" &&
          userData?.invoiceType === "normal1" ? (
          <Normal1InvoiceHtml ref={componentRef} flag={false} sales={false} />
        ) : AppContext?.userInfo.role === "admin" &&
          userData?.invoiceType !== "simple" &&
          userData?.invoiceType !== "normal" &&
          userData?.invoiceType !== "normal1" ? (
          <InvoiceTemplate flag={false} ref={componentRef} type={userData?.invoiceType} />
        ) : (
          <SimpleInvoice ref={componentRef} />
        )}
      </Box>
    </Box>
  );
}

export default PrintComponent;
